goog.provide("shadow.js.shim.module$src$svg$wpp$content$key_svg$default");
shadow.js.shim.module$src$svg$wpp$content$key_svg$default = shadow.js.shim.module$src$svg$wpp$content$key_svg.default;
